/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_RestoringInputs */

const en_plan_restoring = /** @type {(inputs: Plan_RestoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restoring...`)
};

const es_plan_restoring = /** @type {(inputs: Plan_RestoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurando...`)
};

/**
* | output |
* | --- |
* | "Restoring..." |
*
* @param {Plan_RestoringInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_restoring = /** @type {((inputs?: Plan_RestoringInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_RestoringInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_restoring(inputs)
	return en_plan_restoring(inputs)
});